module.exports = __webpack_public_path__ + "static/img/service_shijihaocai.2ac2ef11.png";